import { useSuspenseQuery } from '@tanstack/react-query';
import { myPageService } from 'shared/src/api';
import { queryKey } from 'mypage/src/constant/queryKey';

export const useBeautyInfo = () => {
  return useSuspenseQuery({
    queryKey: queryKey.beautyInfo(),
    queryFn: () => myPageService.getBeautyInfo(),
  });
};
